import React, { Component, } from 'react'

import { getIcon} from './../../cc-imports'

import PropTypes from 'prop-types';

// import './cc-player-item.css'
import './../../styles/css/components/CCPlayerItem/cc-player-item.css'
import CCErrorBoundary from "../CCErrorBoundary/CCErrorBoundary";

class CCPlayerItem extends Component {

    static propTypes = {
        onPress:PropTypes.func,
        onLongPress:PropTypes.func,

        size : PropTypes.string,
        disabled : PropTypes.bool
    };

    static defaultProps = {
        onPress : ()=>{},
        onLongPress : ()=>{},

        size : 'r',
        disabled : false
    };

    constructor(props) {
        super(props)
        this.state = {}
    }


    render() {
        let {player, index, size, disabled} = this.props;
        let image = player.key ? getIcon('player'+index) : getIcon('player0');

        return (
            <CCErrorBoundary>
            <div className="flex-container cc-player-item-container" disabled={disabled} onClick={()=>{if(!disabled)this.props.onPress()}}>
                    <div className="flex-container"
                        style={{opacity: disabled ? 0.5 : 1 ,flexDirection : 'column', alignItems : 'center'}}>
                        <img  src={image} className={'cc-player-item-img'}></img>
                        {
                            player.name!=undefined &&
                            <h3 className={'cc-player-item-title'}>{player.name}</h3>
                        }
                        {
                            player.salary!=undefined &&
                            <h3 className={'cc-player-item-title'}>{'$'+player.salary}</h3>
                        }
                    </div>
            </div>
            </CCErrorBoundary>
        )
    }
}

export default CCPlayerItem


// WEBPACK FOOTER //
// ./src/app/components/CCPlayerItem/CCPlayerItem.js